import { createSelector } from 'reselect';
import RouteManagementColumns from '../../containers/RouteManagementColumns';
import TableDefinitions from '../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.ROUTE_MANAGEMENT_PAGE.isLoading;
export const getData = TableDefinitions.ROUTE_MANAGEMENT_PAGE.getDataFunction();
export const getColumns = createSelector(
  getData,
  (state) => state.global.assetType.appContext,
  (state) => state.userData.userInfo,
  RouteManagementColumns,
);
